import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';
function TitleImage({ pageNumber, photoSource }) {

    const PageNumVariants = {
        initial: {
            y: 200
        },
        animate: {
            y: 0,
            transition: {
                type: 'tween',
                duration: 0.7,
                delay: 1
            }
        }
    }
    const RedFilterVariants = {
        initial: {
            x: "-110%",
            width: "100%"
        },
        animate: {
            x: "110%",
            width: "0%",
            transition: {
                type: 'tween',
                duration: 0.7,
                delay: 0.6
            }
        }
    }
    const BlueFilterVariants = {
        initial: {
            x: "0%",
            // opacity: 0
        },
        animate: {
            x: "110%",
            // opacity: 1,
            transition: {
                type: 'tween',
                duration: 0.7,
                delay: 0.6
            }
        }
    }
    const ImageVariants = {
        initial: {
            scale: 1
        },
        animate: {
            scale: 1,
            transition: {
                type: 'tween',
                duration: 1,
                delay: 0.8
            }
        }
    }
    

    return (
        <TitImgWrap>
            <motion.div className='imagecontainer'
            variants={ImageVariants} initial='initial' animate='animate'
            >
                <motion.img src={photoSource} alt=""/>
                <motion.div className="blue-filter"
                    variants={BlueFilterVariants} initial='initial' animate='animate'
                ></motion.div>
                <motion.div className="red-filter"
                    variants={RedFilterVariants} initial='initial' animate='animate'
                ></motion.div>
            </motion.div>
            <div className="page-num-container">
                <motion.p className='page-num'
                    variants={PageNumVariants} initial='initial' animate='animate'
                >{pageNumber}</motion.p>
            </div>
        </TitImgWrap>
    )
}

const TitImgWrap = styled.div`
    position: relative;
    height: 74%;
    width: 53%;
    margin: 0% 8% 0% auto;
    pointer-events: none;
    box-shadow: 6px 5px 44px 0px #090d2c50; 
    /* overflow: hidden; */
    
    .imagecontainer{ 
        position: relative;
        overflow: hidden;
        height: 100%;
        width: 100%;
    }

    img{
        width: 100%;
        height: 100%;    
        object-fit: cover;
    }

    .blue-filter{
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        right: 0;
        background-color: var(--primary);
        transform: translate(105%, 0%);
    }
    .red-filter{
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        right: 0;
        background-color: var(--secondary);
        transform: translate(105%, 0%);
    }

    @media only screen and (max-width: 500px){
        position: absolute;
        top: 5rem;
        height: 45vh;
        width: 100vw;
        margin: 0;
        align-self: center;
        pointer-events: none;
        box-shadow: 6px 5px 44px 0px #090d2c50;
        display: flex;
        justify-content: center;
        align-items: center;
        box-shadow: none; 
        


        .imagecontainer {
            width: 70%;
        }

    }

`;

export default TitleImage